import Service from "./Service";
const resource = "/advices";

export default {
  async getAll() {
    const resp = await Service.get(`${resource}`);
    const data = resp.data;

    return data;
  },
};
